<script>
const _debounce = require('lodash/debounce');

module.exports = {
  name: 'SearchTabs',
  data() {
    return {
      isDesktop: false,
    };
  },
  computed: {
    activeTab() {
      return this.$store.state.activeTab;
    },
    isStickyOnMobile() {
      return this.$store.state.isStickyOnMobile;
    },
    showBoxShadow() {
      return this.isStickyOnMobile && ['top-results', 'stories'].includes(this.activeTab);
    },
  },
  methods: {
    setActiveTab(tab) {
      this.$store.commit('setActiveTab', tab);
    },
    /**
     * Sets the underline to the active tab on page load and tab change.
     * @param {boolean} init
     */
    updateUnderline(init = false) {
      const tabs = this.$refs.tabNav.querySelectorAll('.tab-nav-item');
      const activeTab = Array.from(tabs).find((tab) =>
        tab.classList.contains('tab-nav-item-active')
      );

      if (activeTab && this.$refs.underline) {
        const { offsetLeft, offsetWidth } = activeTab;

        if (offsetLeft === 0 && offsetWidth === 0 && init) {
          setTimeout(() => this.updateUnderline(true), 10); // Retry after a short delay
          return;
        }

        this.$refs.underline.style.left = `${offsetLeft}px`;
        this.$refs.underline.style.width = `${offsetWidth}px`;
      }
    },
    checkViewport() {
      this.isDesktop = window.innerWidth >= 1180;
    },
    handleResize() {
      this.checkViewport();
      // wait for the DOM to update before updating the underline
      this.$nextTick(() => {
        this.updateUnderline();
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      // place the underline after the DOM is updated
      this.updateUnderline(true);
      this.checkViewport();
    });

    window.addEventListener('resize', this.debouncedResize);
  },
  created() {
    this.debouncedResize = _debounce(this.handleResize, 100);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedResize);
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        this.updateUnderline();
      });
    },
    isDesktop(newIsDesktopValue) {
      if (newIsDesktopValue && this.activeTab === 'top-results') {
        this.setActiveTab('products');
      }
    },
  },
};
</script>

<template>
  <div class="search-tabs" :class="{ 'is-sticky': isStickyOnMobile, 'box-shadow-underline': showBoxShadow }">
    <div class="tab-nav-divider top"></div>
    <ul class="tab-nav" ref="tabNav">
      <li
        class="tab-nav-item"
        :class="{
          'tab-nav-item-active': activeTab === 'top-results',
        }"
        @click="setActiveTab('top-results')"
        v-show="isDesktop === false"
      >
        Top Results
      </li>
      <li
        class="tab-nav-item"
        :class="{
          'tab-nav-item-active': activeTab === 'products',
        }"
        @click="setActiveTab('products')"
      >
        <div class="tab-nav-item-icon products"></div>
        Products
      </li>
      <li
        class="tab-nav-item"
        :class="{
          'tab-nav-item-active': activeTab === 'stories',
        }"
        @click="setActiveTab('stories')"
      >
        <div class="tab-nav-item-icon stories"></div>
        Stories
      </li>
      <div class="tab-nav-underline" ref="underline" />
    </ul>
    <div class="tab-nav-divider bottom"></div>
  </div>
</template>

<style scoped lang="postcss"></style>
